import React from "react";
import { motion } from "framer-motion";

// Definimos el Logo con el nuevo color #013409
const FariasLogo = ({ className }) => (
  <svg viewBox="0 0 300 280" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Líneas del cuadrado en verde #013409 */}
    <path d="M 140 150 H 90 V 50 H 210 V 150" stroke="#013409" strokeWidth="12" strokeLinecap="butt" />
    
    {/* Texto FARÍAS en verde #013409 */}
    <text x="150" y="210" fill="#013409" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontSize="48" fontWeight="bold" letterSpacing="0.1em">
      FARÍAS
    </text>
    
    {/* Texto Abogados en verde #013409 */}
    <text x="150" y="245" fill="#013409" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontSize="28" fontWeight="500">
      Abogados
    </text>
  </svg>
);

export default function Header() {
  return (
    <header
      className="
        relative 
        h-[85vh]
        flex items-center justify-center
        /* Color de fondo crema */
        bg-[#Fbfbf8] 
      "
    >
      {/* Animación de entrada */}
      <motion.div
        className="relative text-center px-4 flex flex-col items-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2 }}
      >
        {/* LOGO SVG RESPONSIVE */}
        <FariasLogo className="w-64 md:w-[500px] h-auto" />

        {/* TEXTO SLOGAN ACTUALIZADO:
            - text-xl md:text-2xl (Más grande)
            - text-gray-500 (Color gris neutro en lugar de verde)
        */}
        <p className="mt-8 text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto whitespace-pre-line font-montserrat font-medium leading-relaxed">
          Estrategias jurídicas <br />
           para decisiones complejas.
        </p>
      </motion.div>
    </header>
  );
}